import { Tooltip } from '@material-ui/core';
import { Col, InputGroup } from 'reactstrap';
import GerenciamentoEmailBase from '../../GerenciamentoEmailBase';
import useGerenciamentoEmail from '../../Hooks/useGerenciamentoEmail';

const GerenciamentoEmailAta = ({ tipo }: { tipo: string }): JSX.Element => {
  const gerenciamento = useGerenciamentoEmail({
    tipo,
  });

  return (
    <GerenciamentoEmailBase
      tipo={tipo}
      {...gerenciamento}
      renderCamposEspecificos={(grupoEmail, handleSetCadDetalheValue) => {
        return (
          <Col sm="3">
            <InputGroup className="input-group-alternative justify-content-left p-2 d-flex align-items-center">
              <Tooltip title="Vai apenas notificar o e-mail sobre a geração da ata">
                <span
                  className={`ml-2 h5 mb-0 mr-2 ${
                    grupoEmail.indicEnviarAta ? 'text-primary' : 'text-muted'
                  }`}
                >
                  Apenas Notificar
                </span>
              </Tooltip>
              <label className="custom-toggle">
                <input
                  type="checkbox"
                  checked={grupoEmail.indicEnviarAta}
                  onChange={text =>
                    handleSetCadDetalheValue(
                      grupoEmail,
                      'indicEnviarAta',
                      text.target.checked,
                    )
                  }
                />
                <span className="custom-toggle-slider rounded-circle" />
              </label>
              <Tooltip title="Vai enviar a ata como Anexo para esse e-mail">
                <span
                  className={`ml-2 h5 mb-0 mr-2 ${
                    grupoEmail.indicEnviarAta ? 'text-primary' : 'text-muted'
                  }`}
                >
                  Enviar como Anexo
                </span>
              </Tooltip>
            </InputGroup>
          </Col>
        );
      }}
    />
  );
};

export default GerenciamentoEmailAta;
